<template>
  <div class="mb-4" :id="wrapperId" v-if="isMounted">
    <div class="thumbnail-wrapper">
      <button
        v-if="!!currentValue"
        @click="remove"
        type="button"
        class="btn btn-danger btn-remove"
      >
        X
      </button>

      <img class="thumbnail" :src="currentValue" :key="currentValue" v-if="!!currentValue" />
    </div>

    <FormKit
      type="hidden"
      v-model="currentValue"
      :key="currentValue"
      v-bind="$attrs"
    />

    <button
      class="btn btn-primary"
      data-toggle="modal"
      :data-target="`#${modalId}`"
      type="button"
      @click="addMethod"
    >
      Selecteer afbeelding
    </button>

    <div
      :id="modalId"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      style="z-index: 10000"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body p-0">
            <iframe
              src="/admin/laravel-filemanager?type=image"
              class="filemanager"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidV4 } from "uuid";

export default {
  name: "FormKitImage",
  inheritAttrs: false,
  props: {
    modelValue: {},
    value: {},
  },
  data() {
    let id = uuidV4();

    return {
      id,
      wrapperId: `form-kit-image-wrapper-${id}`,
      modalId: `form-kit-image-modal-${id}`,
      isMounted: false,
      currentValue: this.modelValue ?? this.value,
    };
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    remove() {
      this.currentValue = "";
    },
    addMethod() {
      // Store reference to this component instance and modal ID
      const self = this;
      const modalId = this.modalId;
      
      // Set the global SetUrl function to handle this specific instance
      window.SetUrl = (images) => {
        // Convert full URL to relative path by removing the domain
        let imageUrl = images[0].url;
        if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
          // Extract just the path part (everything after the domain)
          const url = new URL(imageUrl);
          imageUrl = url.pathname;
        }
        
        self.currentValue = imageUrl;
        $(`#${modalId}`).modal("hide");
        
        // Clear the callback after use to prevent conflicts
        window.SetUrl = null;
      };
    },
  },
  watch: {
    currentValue() {
      this.$emit("input", this.currentValue);
      this.$emit("update:modelValue", this.currentValue);
    },
  },
};
</script>

<style>
.modal-backdrop {
  display: none !important;
}

.modal {
  background-color: rgba(0, 0, 0, 0.5);
}

.filemanager {
  width: 100%;
  height: 500px;
}

.thumbnail-wrapper {
  position: relative;
  margin-bottom: 0.25rem;
}

.thumbnail {
  width: 144px;
  height: 144px;
  object-fit: contain;
  display: block;
}

.btn-remove {
  position: absolute;
  left: -10px;
  top: -5px;
}
</style>